import moment from 'moment-timezone';

export const summaryDate = (value, pattern = 'D MMM') => value
    ? moment.tz(value, 'America/Lima').locale('es').format(pattern) : 'Sin fecha';

export const summaryAmount = (value, currency) => {
    if (value === null || value === undefined || !Number.isFinite(Number(value))) return '—';
    return `${currency?.simbolo || currency?.codigo || ''} ${new Intl.NumberFormat('es-PE', {
        minimumFractionDigits: 2, maximumFractionDigits: 2,
    }).format(Number(value))}`.trim();
};

export const solesAmount = value => summaryAmount(value, {simbolo:'S/'});
